import type { KeycloakTokenParsed } from "keycloak-js";

/**
 * The Keycloak client the desk deployment authenticates as.
 *
 * This repo ships to two hosts: app.newsquawk.com as `react-frontend-client`,
 * and desk.newsquawk.com as this one. pref-storage grants NEWSQUAWK ownership
 * by looking for the desk role under exactly this client
 * (`config/desk.py: desk_client_ids`), so matching it here keeps the button
 * and the permission in step.
 */
export const DESK_CLIENT_ID = "react-frontend-publisher";

export const DESK_ROLE = "internal-newsquawk-user";

/**
 * May this token publish to the Newsquawk library?
 *
 * Kept in its own module, free of React and `initKeycloak`, so the rule can be
 * unit-tested without dragging in browser globals — importing the hook pulls
 * the Keycloak instance and, through it, `window`.
 *
 * Both halves matter. An internal user on app.newsquawk.com holds the same
 * role under `react-frontend-client`, but writes from that client are not
 * granted desk rights, so a publish toggle there would 403 on every save.
 */
export function isDeskToken(
  activeClientId: string | undefined,
  tokenParsed: KeycloakTokenParsed | null | undefined
): boolean {
  if (!tokenParsed) return false;
  if (activeClientId !== DESK_CLIENT_ID) return false;
  const roles = tokenParsed.resource_access?.[DESK_CLIENT_ID]?.roles ?? [];
  return roles.includes(DESK_ROLE);
}
